import React from "react";
import { format } from "date-fns";
import { separator } from "../utils/separator";
import "../styles/components/billing-table.scss";

const checkType = cost => {
  if (cost < 0) {
    return "decrease";
  }
  return "increase";
};

const BillingTable = props => {
  return (
    <div className="table-container">
      <table className="table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Cost</th>
            <th>Description</th>
            <th>Code</th>
            <th>Date</th>
          </tr>
        </thead>
        <tbody>
          {props.data.map(el => {
            return (
              <tr
                key={el.id}
                className={
                  checkType(el.amount) === "decrease" ? "decrease" : "increase"
                }
              >
                <td>
                  <i />
                  {checkType(el.amount) === "decrease"
                    ? "Decrease Credit"
                    : "Increase Credit"}
                </td>
                <td className="amount">{`${formatSign(
                  el.amount,
                  el.transaction_type.includes("increase")
                )} Tomans`}</td>
                <td className="description">{el.description}</td>
                <td className="transaction-code">
                  {el.external_identifier !== null
                    ? el.external_identifier
                    : "----"}
                </td>
                <td className="date">
                  {format(new Date(el.creation_time + ""), "y/MM/dd - HH:mm")}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

const formatSign = (amount, inc) =>
  `${inc ? "+" : "-"} ${separator(Math.abs(amount))}`;

export default BillingTable;
